import { render, staticRenderFns } from "./PreviewPanel.vue?vue&type=template&id=0475b5a0&scoped=true&"
import script from "./PreviewPanel.vue?vue&type=script&lang=js&"
export * from "./PreviewPanel.vue?vue&type=script&lang=js&"
import style0 from "./preview_panel.scss?vue&type=style&index=0&id=0475b5a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0475b5a0",
  null
  
)

export default component.exports